export const environment = {
  production: false,
  supabase: {
    url: 'https://supabase.antflow.cloud',
    key: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyAgCiAgICAicm9sZSI6ICJhbm9uIiwKICAgICJpc3MiOiAic3VwYWJhc2UtZGVtbyIsCiAgICAiaWF0IjogMTY0MTc2OTIwMCwKICAgICJleHAiOiAxNzk5NTM1NjAwCn0.dc_X5iR_VP_qT0zsiyj_I_OZ2T9FtRU2BBNWN8Bu4GE'
  },
  n8nBaseUrl: 'https://n8n.antflow.cloud',
  apiUrls: {
    uploadCV: 'https://n8n.antflow.cloud/webhook/upload_cv',
    queryCV: 'https://n8n.antflow.cloud/webhook/query_cv',
    stats: 'https://n8n.antflow.cloud/webhook/stats',
    chat: 'https://n8n.antflow.cloud/webhook/chat',
    search: 'https://n8n.antflow.cloud/webhook/search'
  },
  upload: {
    maxFileSize: 10 * 1024 * 1024,
    allowedTypes: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ]
  }
};
